import { assets } from "@/lib/assets"
import {Menu, X} from 'lucide-react'
import { useEffect, useState } from "react"

const links = [
  { href: "#about", label: "ABOUT" },
  { href: "#story", label: "STORY" },
  { href: "#product", label: "PRODUCT" },
]

function Header() {
  const [open, setOpen] = useState(false)
  const [light, setLight] = useState(true)

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll<HTMLElement>("[data-nav]"))
    if (sections.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
        const tone = visible?.target.getAttribute("data-nav")
        if (tone === "light" || tone === "dark") {
          setLight(tone === "light")
        }
      },
      { rootMargin: "-8% 0px -70% 0px", threshold: [0.1, 0.25, 0.5] },
    )

    sections.forEach((section) => observer.observe(section))
    return () => observer.disconnect()
  }, [])

  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div className="mx-auto grid h-16 max-w-6xl grid-cols-[auto_1fr_auto] items-center px-8 md:h-20 md:px-8">
        <a href="#hero" className="inline-flex shrink-0 items-center" aria-label="MR.EAR 耳朵先生">
          <img
            src={assets.logo}
            alt="MR.EAR 耳朵先生"
            className="h-10 w-auto object-contain md:h-12"
          />
        </a>

        <nav className={`hidden grid-cols-3 items-center text-center text-[11px] tracking-[0.28em] md:grid ${light ? "text-white/80" : "text-slate-500"}`}>
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`transition-colors ${light ? "hover:text-white" : "hover:text-slate-800"}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          className={`inline-flex h-9 w-9 items-center justify-center justify-self-end md:hidden ${light ? "text-white" : "text-slate-700"}`}
          onClick={() => setOpen(true)}
          aria-label="開啟選單"
        >
          <Menu size={20} />
        </button>
        <span className="hidden h-9 w-9 md:block" aria-hidden="true" />
      </div>

      {open ? (
        <div className="fixed inset-0 z-50 bg-[#163044]/96 px-8 py-8 text-white md:hidden">
          <div className="mb-12 flex items-center justify-between">
            <img src={assets.logo} alt="MR.EAR 耳朵先生" className="h-10 w-auto object-contain" />
            <button type="button" onClick={() => setOpen(false)} aria-label="關閉選單">
              <X size={22} />
            </button>
          </div>
          <div className="flex flex-col gap-8 text-sm tracking-[0.32em]">
            {links.map((link) => (
              <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            ))}
            <a href="#order" onClick={() => setOpen(false)}>ORDER</a>
            <a href="#contact" onClick={() => setOpen(false)}>CONTACT</a>
          </div>
        </div>
      ) : null}
    </header>
  )
}

export default Header
